import { render, staticRenderFns } from "./PayView.vue?vue&type=template&id=1018a706&scoped=true&"
import script from "./PayView.vue?vue&type=script&lang=js&"
export * from "./PayView.vue?vue&type=script&lang=js&"
import style0 from "./PayView.vue?vue&type=style&index=0&id=1018a706&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1018a706",
  null
  
)

export default component.exports